export const GENERIC_STATE = {
  idle: "idle",
  processing: "processing",
  success: "success",
  error: "error",
} as const;
export type GenericState = (typeof GENERIC_STATE)[keyof typeof GENERIC_STATE];

export const PAYMENT_STATE = {
  ...GENERIC_STATE,
  authorised: "authorised",
  cancelled: "cancelled",
  refused: "refused",
};

export type TPaymentState = (typeof PAYMENT_STATE)[keyof typeof PAYMENT_STATE];

export const ASYNC_DATA_REQUEST_STATUS = {
  idle: "idle",
  pending: "pending",
  success: "success",
  error: "error",
} as const;

export type TAsyncDataRequestStatus =
  (typeof ASYNC_DATA_REQUEST_STATUS)[keyof typeof ASYNC_DATA_REQUEST_STATUS];
